import React, { useEffect, useState } from "react";
import { Grid, TextField, Button, Typography, Select, MenuItem, FormControl, InputLabel, Backdrop, CircularProgress, FormHelperText } from "@mui/material";
import CustomSnackbar from "../../../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import { useNavigate } from "react-router-dom";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const AddMiscellaneousFees = ( { enquiryData, onClose }) => {
    const userId = localStorage.getItem("userId");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [pteId, setPteId] = useState(null);
    const [toeflId, setToeflId] = useState(null);
       const [greId, setGreId] = useState(null);
       const [duolingoId, setDuolingoId] =useState(null)
    const [testTypeId, setTestTypeId] = useState(null);
     const [subtestTypeId, setSubTestTypeId] = useState(null);
    const [totalTestFees, setTotalTestFees] = useState(null);
    const [studentPaidAmount, setStudentPaidAmount] = useState(null);
    const [voucherAmount, setVoucherAmount] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [testTypeList, setTestTypeList] = useState([]);
    const [subTestTypeList, setSubTestTypeList] = useState([])
    const [testtypeLoading, setTestTypeLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [errors, setErrors] = useState({});


    // Calculate Revenue Achievement
    const revenueAchievement = Number(studentPaidAmount) - Number(voucherAmount);

    useEffect(() => {
        setTestTypeLoading(true);
        fetch(
          `${API_ENDPOINT}route2.0/testtype-by-subservice/${enquiryData?.sub_service_id?.id}`
        )
          .then((response) => response.json())
          .then((data) => {
            setTestTypeList(data);
            setTestTypeLoading(false);
          })
          .catch((error) => {
            console.error("Error fetching task items:", error);
            setTestTypeLoading(false);
          });
      }, [enquiryData?.sub_service_id?.id]);

      useEffect(() => {
          // Fetch menu items using the fetch function
          fetch(`${API_ENDPOINT}route2.0/getsubtesttype/${testTypeId}`)
            .then((response) => response.json())
            .then((data) => {
              setSubTestTypeList(data);
            })
            .catch((error) => {
              console.error("Error fetching testtypes:", error);
              setSubTestTypeList([]);
            });
        }, [testTypeId]);

      const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
      };

    // Validate inputs before submission
const validateForm = () => {
    let newErrors = {};

    if (!testTypeId) newErrors.testTypeId = "Test Type is required";
    
    if(testTypeId && testTypeId == 9){
        if (!pteId?.trim()) {
            newErrors.pteId = "PTE ID is required";
        } else if (!/^[A-Za-z0-9]{9}$/.test(pteId)) {
            newErrors.pteId = "PTE ID must be a 9 digit ID";
        }
        if (!subtestTypeId) newErrors.subtestTypeId = "Sub Test Type is required";
    }

    if(testTypeId && testTypeId == 7){
        if (!toeflId?.trim()) {
            newErrors.toeflId = "TOEFL ID is required";
        } else if (!/^[A-Za-z0-9]{8}$/.test(toeflId)) {
            newErrors.toeflId = "TOEFL ID must be a 8 digit ID";
        }
    }

     if(testTypeId && testTypeId == 1){
        if (!greId?.trim()) {
            newErrors.greId = "GRE ID is required";
        } else if (!/^[A-Za-z0-9]{16}$/.test(greId)) {
            newErrors.greId = "GRE ID must be a 16 digit ID";
        }
    }

     if(testTypeId && testTypeId == 6){
        if (!duolingoId?.trim()) {
            newErrors.duolingoId = "DUOLINGO ID is required";
        } else if (!/^[A-Za-z0-9]{8}$/.test(duolingoId)) {
            newErrors.duolingoId = "DUOLINGO ID must be a 8 digit ID";
        }
    }


    if (!totalTestFees) newErrors.totalTestFees = "Total Test Fees is required";
    if (!studentPaidAmount) newErrors.studentPaidAmount = "Student Paid Amount is required";
    if (!voucherAmount) newErrors.voucherAmount = "Voucher Amount is required";
    if (!selectedFile) newErrors.file = "Receipt upload is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        if (!revenueAchievement) {
            showSnackbar("Revenue achieved cannot be null", "error");
            return;
        }

        if (revenueAchievement && revenueAchievement <= 0) {
            showSnackbar("Voucher amount cannot be more than paid amount", "error");
            return;
        }

        setIsLoading(true);

        const formData = new FormData();
        formData.append("file", selectedFile);
        if (testTypeId === 9) {
            formData.append("pte_id", pteId);
        } else if (testTypeId === 7) {
            formData.append("pte_id", toeflId);
        }
        else if (testTypeId === 1) {
            formData.append("pte_id", greId);
        }
 else if (testTypeId === 6) {
            formData.append("pte_id", duolingoId);
        }

        formData.append("enquiry_id", enquiryData.id);
        formData.append("test_fees", totalTestFees );
        formData.append("paid_amount", studentPaidAmount);
        formData.append("voucher_amount", voucherAmount);
        formData.append("revenue_amount", revenueAchievement);
        formData.append("test_type_id", testTypeId);
        if(subtestTypeId) formData.append("sub_test_type_id", subtestTypeId);
        formData.append("user_id", parseInt(userId))

        fetch(`${API_ENDPOINT}miscellaneousfees/addmiscellaneousfeebyuser`, {
            method: "POST",
            body: formData,
        })
        .then((response) => {
            if(response.ok){
                setIsLoading(false);
                showSnackbar("Miscellaneous fee added successfully", "success")
                setTimeout(() => {
                    onClose()
                }, 2000)
            }else if(response.status == 401){
                setIsLoading(false);
                showSnackbar("Unauthorized user", "error")
                navigate("/page401")
            }
            else if(response.status === 400){
                setIsLoading(false);
                showSnackbar("Error uploading the receipt", "error")
            } else if(response.status === 409){
                setIsLoading(false);
                showSnackbar("A duplicate miscalleneous fee with the same PTE ID and enquiry ID is pending", "error")
            } else if(response.status === 403){
                setIsLoading(false);
                showSnackbar("Error adding miscellaneous fee", "error")
            } else if(response.status === 405){
                setIsLoading(false);
                showSnackbar("Enquiry ID cannot be null", "error")
            } else {
                setIsLoading(false);
                showSnackbar("Error adding miscellaneous fee", "error")
            }
        })
        .catch((error) => {
            console.error("Error updating adding miscellaneous fee:", error);
            showSnackbar("Server error", "error")
            setIsLoading(false);
          });
    };

    const showSnackbar = (message, severity) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const handleNumericInput = (e, setter) => {
        let value = e.target.value;
      
        // Allow empty string (so user can delete/clear)
        if (value === "") {
          setter("");
          return;
        }
      
        // Remove leading zeros and restrict to positive numbers only
        if (/^\d+$/.test(value)) {
          value = String(Number(value));
          setter(value);
        }
      };
      

    return (
        <>
            <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
                <Typography variant="h4" color="secondary" fontWeight={800} marginRight={2}>
                    Submitting Miscellaneous Fee Details ....
                </Typography>
                <CircularProgress color="secondary" />
            </Backdrop>
    
            <Grid container spacing={2}>
                
                {/* Test Type */}
                <Grid item xs={12} md={6}>
                    <FormControl  fullWidth error={!!errors.testTypeId}>
                        <InputLabel id="test-type-label"  >Test Booked</InputLabel>
                        <Select
                       label="Test Booked"
                            labelId="test-type-label"
                            value={testTypeId}
                            onChange={(e) => setTestTypeId(e.target.value)}
                            sx={{ borderRadius: "15px" }}
                        >
                            {testTypeList.length === 0 ? (
                                <MenuItem value="">
                                    No test types found for this sub service
                                </MenuItem>
                            ) : (
                                testTypeList.map((testType) => (
                                    <MenuItem key={testType.id} value={testType.id}>
                                        {testType.name}
                                    </MenuItem>
                                ))
                            )}
                        </Select>
                        {errors.testTypeId && <FormHelperText>{errors.testTypeId}</FormHelperText>}
                    </FormControl>
                </Grid>

                {/* sub Test Type */}
                {testTypeId == 9 && (
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth error={!!errors.subtestTypeId}>
                        <InputLabel id="sub-test-type-label">Sub Test Type</InputLabel>
                        <Select
                         label="Sub Test Type"
                            labelId="sub-test-type-label"
                            value={subtestTypeId}
                            onChange={(e) => setSubTestTypeId(e.target.value)}
                            sx={{ borderRadius: "15px" }}
                        >
                            {subTestTypeList.length === 0 ? (
                                <MenuItem value="">
                                    No sub test types found for this test type
                                </MenuItem>
                            ) : (
                                subTestTypeList.map((testType) => (
                                    <MenuItem key={testType.id} value={testType.id}>
                                        {testType.name}
                                    </MenuItem>
                                ))
                            )}
                        </Select>
                        {errors.subtestTypeId && <FormHelperText>{errors.subtestTypeId}</FormHelperText>}
                    </FormControl>
                </Grid>
                )}

                {/* PTE ID */}
                {testTypeId == 9 && (
                <Grid item xs={12} md={12}>
                    <TextField
                        fullWidth
                        label="PTE test reference number(PTE ID)"
                        variant="outlined"
                        value={pteId}
                        onChange={(e) => setPteId(e.target.value.toUpperCase())}
                        error={!!errors.pteId}
                        helperText={errors.pteId}
                        InputProps={{ style: { borderRadius: "15px" } }}
                    />
                </Grid>
                )}

                {testTypeId == 7 && (
                <Grid item xs={12} md={12}>
                    <TextField
                        fullWidth
                        label="TOEFL test reference number(TOEFL ID)"
                        variant="outlined"
                        value={toeflId}
                        onChange={(e) => setToeflId(e.target.value.toUpperCase())}
                        error={!!errors.toeflId}
                        helperText={errors.toeflId}
                        InputProps={{ style: { borderRadius: "15px" } }}
                    />
                </Grid>
                )}

                 {testTypeId == 1 && (
                <Grid item xs={12} md={12}>
                    <TextField
                        fullWidth
                        label="GRE test reference number(GRE ID)"
                        variant="outlined"
                        value={greId}
                        onChange={(e) => setGreId(e.target.value.toUpperCase())}
                        error={!!errors.greId}
                        helperText={errors.greId}
                        InputProps={{ style: { borderRadius: "15px" } }}
                    />
                </Grid>
                )}
    
       {testTypeId == 6 && (
                <Grid item xs={12} md={12}>
                    <TextField
                        fullWidth
                        label="DUOLINGO test reference number(DUOLINGO ID)"
                        variant="outlined"
                        value={duolingoId}
                        onChange={(e) => setDuolingoId(e.target.value.toUpperCase())}
                        error={!!errors.duolingoId}
                        helperText={errors.duolingoId}
                        InputProps={{ style: { borderRadius: "15px" } }}
                    />
                </Grid>
                )}
    
                {/* Total Test Fees */}
                <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Total Test Fees"
                    variant="outlined"
                    type="number"
                    value={totalTestFees}
                    onChange={(e) => handleNumericInput(e, setTotalTestFees)}
                    error={!!errors.totalTestFees}
                    helperText={errors.totalTestFees}
                    InputProps={{ style: { borderRadius: "15px" }}}
                />
                </Grid>

                <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Student Paid Amount"
                    variant="outlined"
                    type="number"
                    value={studentPaidAmount}
                    onChange={(e) => handleNumericInput(e, setStudentPaidAmount)}
                    error={!!errors.studentPaidAmount}
                    helperText={errors.studentPaidAmount}
                    InputProps={{ style: { borderRadius: "15px" } }}
                />
                </Grid>

                <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Voucher Amount"
                    variant="outlined"
                    type="number"
                    value={voucherAmount}
                    onChange={(e) => handleNumericInput(e, setVoucherAmount)}
                    error={!!errors.voucherAmount}
                    helperText={errors.voucherAmount}
                    InputProps={{ style: { borderRadius: "15px" } }}
                />
                </Grid>

    
                {/* Revenue Achievement */}
                <Grid item xs={12}>
                    <Typography variant="h6">
                        Revenue Achievement: {isNaN(revenueAchievement) ? 0 : revenueAchievement}
                    </Typography>
                </Grid>
    
                {/* Upload Receipt */}
                <Grid item xs={12}>
                    <Typography variant="h6">Upload Receipt</Typography>
                    <input type="file" onChange={handleFileChange} accept="image/*,application/pdf" />
                    {errors.file && <Typography color="error">{errors.file}</Typography>}
                </Grid>
    
                {/* Submit Button */}
                <Grid item xs={12} display="flex" justifyContent="right">
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        Submit
                    </Button>
                </Grid>
            </Grid>
        {/* Snackbar Notification */}
        <CustomSnackbar
                open={snackbarOpen}
                onClose={() => setSnackbarOpen(false)}
                message={snackbarMessage}
                severity={snackbarSeverity}
            />
        </>
    );
};

export default AddMiscellaneousFees;
